import LiveClassLessonDao from '../dao/live-class-lesson.dao';
import type { Environment } from '../interfaces/environment';

export abstract class LiveClassLessonService {
  static getLiveClassLessons(
    env: Environment,
    contactId: string,
    isTeacher: boolean
  ) {
    return LiveClassLessonDao.getLiveClassLesson(env, contactId, isTeacher);
  }
}
